import React from 'react'
import classNames from 'classnames'
import { Image as ImageType, VideoSource, RichTextContent } from 'shared-types'
import { Image } from '~/components/Image'
import { ProductCarousel } from '~/components/ProductCarousel'
import { getImageSrc } from '~/helpers'
import RichText from '../RichText/RichText'
import { VideoPlayer } from '../VideoPlayer'
import styles from './MakerHubArticleContentBlock.module.css'
import {
  MakerHubArticleContent,
  MakerHubArticleContentBlockProps,
} from './MakerHubArticleContentBlock.types'

const MakerHubArticleContentBlock = ({
  className,
  content,
}: MakerHubArticleContentBlockProps) => {
  const makerHubRenderText = (richText: RichTextContent, key: string) => {
    return (
      <div key={key} className={styles?.richtext}>
        <RichText content={richText} />
      </div>
    )
  }

  const makerHubRenderVideo = (source: VideoSource[], key: string) => {
    return (
      <div key={key} className={classNames(styles.video, 'w-full')}>
        <VideoPlayer source={source} muted={false} autoplay={false} />
      </div>
    )
  }

  const makerHubRenderImage = (image: ImageType, key: string) => {
    return (
      <Image
        key={key}
        className={classNames('mx-auto rounded-md py-4 first-of-type:pt-0')}
        src={getImageSrc(image.src, '800')}
        addSrcSet={false}
        sources={
          <>
            <source
              srcSet={getImageSrc(image.src, '1000')}
              media='(max-width: 1024px)'
            />
            <source
              srcSet={getImageSrc(image.src, '700')}
              media='(max-width: 768px)'
            />
            <source
              srcSet={getImageSrc(image.src, '500')}
              media='(max-width: 500px)'
            />
          </>
        }
        alt={image.altText}
        width={image.width}
        height={image.height}
        loading='eager'
      />
    )
  }

  const renderContentBlock = (block: MakerHubArticleContent, index: number) => {
    if (block.type === 'rich-text') {
      return makerHubRenderText(block.richText, `${block.uid}_text_${index}`)
    }
    if (block.type === 'image') {
      return makerHubRenderImage(block.image, `${block.uid}_img_key_${index}`)
    }
    if (block.type === 'video') {
      return makerHubRenderVideo(block.video, block.uid || `video_${index}`)
    }
    if (block.type === 'product carousel') {
      return (
        <ProductCarousel
          products={block.productCarousel.products}
          id={block.productCarousel.id}
        />
      )
    }
    return null
  }

  return (
    <div className={classNames(styles.root, 'flex flex-col gap-6', className)}>
      {content?.map((block, index) => {
        return renderContentBlock(block, index)
      })}
    </div>
  )
}

export default MakerHubArticleContentBlock
